(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 768;

  let toolbar = null;
  let originalTop = 0;
  let ticking = false;

  function init() {
    toolbar = document.getElementById('searchspring-toolbar');
    if (!toolbar) return;

    // Store the original position
    updateOriginalTop();

    // Add scroll listener with requestAnimationFrame for smooth performance
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', handleResize);

    // Initial check
    handleScroll();
  }

  function updateOriginalTop() {
    const rect = toolbar.getBoundingClientRect();
    originalTop = rect.top + window.pageYOffset;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
    }
  }

  function handleScroll() {
    ticking = false;

    if (!toolbar || window.innerWidth >= MOBILE_BREAKPOINT) {
      toolbar?.classList.remove('is-sticky');
      return;
    }

    const scrollTop = window.pageYOffset;
    const shouldBeSticky = scrollTop >= originalTop;

    toolbar.classList.toggle('is-sticky', shouldBeSticky);
  }

  function handleResize() {
    if (!toolbar) return;

    // Update original position on resize
    if (!toolbar.classList.contains('is-sticky')) {
      updateOriginalTop();
    }

    if (window.innerWidth >= MOBILE_BREAKPOINT) {
      toolbar.classList.remove('is-sticky');
    } else {
      handleScroll();
    }
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();